import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import { CTAButton } from '../types';

interface CTAButtonsProps {
  buttons: CTAButton[];
}

const CTAButtons = ({ buttons }: CTAButtonsProps) => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.6 }}
      className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12"
    >
      {buttons.map((button) => (
        <Button
          key={button.id}
          variant={button.variant}
          size="lg"
          iconName={button.iconName}
          iconPosition="left"
          iconSize={20}
          onClick={button.action}
          className={button.variant === 'default' ? 'gradient-cta' : ''}
        >
          {button.label}
        </Button>
      ))}
    </motion.div>
  );
};

export default CTAButtons;